import React from 'react';
import styled from 'styled-components';

interface OwnProps {
  onClickCallbackShopMenu: () => any;
}

const StyledCloseIcon = styled.button`
@media (max-width: 992px) {
  position: fixed;
  top: 1rem;
  right: 24px;
  flex-direction: column;
  background: transparent;
  width: 1.5rem;
  height: 1.5rem;
  border: none;
  justify-content: space-around;
  padding: 0;
  cursor: pointer;
  z-index: 1002;
  display: flex;
}

  @media (max-width: 768px) {
    top: 8px;
    right: 16px;
  }


  div {
    width: 1.5rem;
    height: 0.18rem;
    border-radius: 5px;
    position: relative;
    transform-origin: 1px;
    background: ${(props: any) => (props.theme.primary)};

    :first-child {
      transform: rotate(45deg);
    }

    :nth-child(2) {
      opacity: 0;
    }

    :nth-child(3) {
      transform: rotate(-45deg);
    }
  }
}
`;

const CloseIcon = (props: OwnProps) => {
  const { onClickCallbackShopMenu } = props;
  return (
    <StyledCloseIcon
      onClick={() => onClickCallbackShopMenu()}
      aria-label="close"
    >
      <div />
      <div />
      <div />
    </StyledCloseIcon>
  );
};

export default CloseIcon;
